import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { UpdatePinMutationMutation, UpdatePinMutationMutationVariables } from "../../../../schemaTypes";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

const updatePinMutation = gql`
  mutation UpdatePinMutation($input: UpdatePinInput!) {
    updatePin(input: $input) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitUpdatePin: (
        values: UpdatePinMutationMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      error: any;
      message: string | null;
    }
  ) => ReactElement | null;
}

export const UpdatePinController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    UpdatePinMutationMutation,
    UpdatePinMutationMutationVariables
  >(updatePinMutation);

  const submitUpdatePin = async (values: UpdatePinMutationMutationVariables) => {
    const { data: {updatePin} }:any = await mutate({ variables: values });

    if (updatePin.errors) {
      return normalizeErrors(updatePin.errors);
    }

    return null;
  };

  const message = data?.updatePin?.message || null;

  return children({
    submitUpdatePin,
    loading,
    error,
    message,
  });
};

